<template>
  <v-container>
    <h3 class="mb-4">Assegnazioni duplicate</h3>
    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="totalItems"
      :options.sync="pagination"
      :loading="loading"
      hide-default-footer
      class="elevation-1"
    ></v-data-table>
    <Paginator
      :total-items="totalItems"
      :page.sync="pagination.page"
      :items-per-page.sync="pagination.itemsPerPage"
      @change="fetchData"
    />
  </v-container>
</template>
<script>
import { anomalyService } from '../../../utils/services/anomaly.service';
import Paginator from '../../../components/shared/Paginator';

export default {
  name: 'AnomalyDuplicateAssignments',
  components: { Paginator },
  data() {
    return {
      loading: false,
      items: [],
      totalItems: 0,
      pagination: { page: 1, itemsPerPage: 20 },
      headers: [
        { text: 'Docente', value: 'docente' },
        { text: 'ISBN', value: 'isbn' },
        { text: 'Titolo', value: 'title' },
        { text: 'Volte', value: 'volte' },
        { text: 'IDs', value: 'campaign_book_ids' },
      ],
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const response = await anomalyService.getDuplicateAssignments({
          page: this.pagination.page,
          itemsPerPage: this.pagination.itemsPerPage,
        });
        this.items = response.data.data;
        this.totalItems = response.data.total;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
